import { Instagram, Youtube, Music } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="relative px-6 md:px-10 pt-20 pb-10 bg-[#1B4D3E] text-white border-t-4 border-black overflow-hidden"
            data-testid="site-footer"
        >
            {/* Soft glow to give it its own atmosphere */}
            <div className="pointer-events-none absolute -top-32 -left-24 w-[500px] h-[500px] rounded-full bg-[#D4A017] opacity-10 blur-3xl" aria-hidden />
            <div className="pointer-events-none absolute -bottom-40 -right-32 w-[500px] h-[500px] rounded-full bg-[#C2410C] opacity-15 blur-3xl" aria-hidden />

            <div className="relative max-w-7xl mx-auto">
                <div className="grid md:grid-cols-12 gap-10 md:gap-14">
                    <div className="md:col-span-6">
                        <div className="flex items-center gap-2.5 text-[#D4A017]">
                            <span className="flex gap-[3px] items-end h-5">
                                <span className="eq-bar" />
                                <span className="eq-bar" />
                                <span className="eq-bar" />
                                <span className="eq-bar" />
                                <span className="eq-bar" />
                            </span>
                            <span className="font-display text-base tracking-tight font-bold uppercase text-white">
                                My First Single
                            </span>
                        </div>
                        <p className="mt-5 font-display font-black text-3xl md:text-4xl tracking-tighter leading-[0.95] max-w-md">
                            From dream to <span className="text-[#D4A017]">release.</span>
                        </p>
                        <p className="mt-6 text-white/70 text-sm max-w-sm leading-relaxed">
                            A boutique artist development experience for
                            everyday people who want to release real music.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-widest font-bold text-[#D4A017] mb-5">Explore</div>
                        <ul className="space-y-3 text-white/90">
                            <li><a href="#how-it-works" className="link-underline">Journey</a></li>
                            <li><a href="#genres" className="link-underline">Genres</a></li>
                            <li><a href="#lessons" className="link-underline">Costs</a></li>
                            <li><a href="#teachers" className="link-underline">Book a call</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <div className="font-mono text-[10px] uppercase tracking-widest font-bold text-[#D4A017] mb-5">Follow</div>
                        <div className="flex items-center gap-3">
                            <a
                                aria-label="Instagram"
                                href="#"
                                className="w-10 h-10 rounded-full bg-[#C2410C] hover:bg-[#D4A017] hover:text-black text-white border-2 border-black flex items-center justify-center transition-colors"
                                data-testid="footer-instagram"
                            >
                                <Instagram size={16} />
                            </a>
                            <a
                                aria-label="YouTube"
                                href="#"
                                className="w-10 h-10 rounded-full bg-[#D4A017] hover:bg-[#C2410C] hover:text-white text-black border-2 border-black flex items-center justify-center transition-colors"
                                data-testid="footer-youtube"
                            >
                                <Youtube size={16} />
                            </a>
                            <a
                                aria-label="Spotify"
                                href="#"
                                className="w-10 h-10 rounded-full bg-black hover:bg-[#C2410C] text-white border-2 border-black flex items-center justify-center transition-colors"
                                data-testid="footer-spotify"
                            >
                                <Music size={16} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-7 border-t border-white/20 flex flex-col md:flex-row gap-3 justify-between text-xs text-white/60 font-mono">
                    <span>© {new Date().getFullYear()} My First Single. All rights reserved.</span>
                    <span>Made for first‑time artists worldwide.</span>
                </div>
            </div>
        </footer>
    );
}
